<template>
  <v-card class="card-view" v-if="cardOpen" width="420">
    <div class="card-title-container px-4 py-2 mt-3">
      <v-card-title class="pa-0 card-title">Ticket Views</v-card-title>
      <v-icon class="close-icon" @click="cardOpen = false">mdi-close</v-icon>
    </div>
    <v-card-subtitle class="text-subtitle-1 px-4 py-2 mb-4">Customise your view by selecting the Sections you need most.</v-card-subtitle>
    <v-card-text @scroll="handleScroll">
      <v-list>
        <draggable v-model="listItems">
          <template v-for="(item, index) in listItems">
            <v-hover v-slot:default="{ hover, props }" v-bind:key="index">
              <v-list-item
                :key="item.id"
                :title="item.label"
                v-bind="props"
                class="justify-space-between card-item"
              >
                <v-checkbox
                  hide-details 
                  class="list-title mt-0 pt-0" 
                  color="mpBlue"
                  v-model="item.isChecked"
                  :class="{'low-opacity': item.filtername==='all-tickets'}"
                  @click.native.capture="handleSelection($event, item)"
                >
                  <template v-slot:label>
                    <span class="label">{{ getModified(item.label, 22) }}</span>
                  </template>
                </v-checkbox>
                <template v-if="hover">
                  <span>
                    <span v-if="!standardTabs.includes(item.id) && $can('create','tickets')">
                      <v-icon class="mr-3" @click.stop="editFilterView(item.id)">mdi-pencil</v-icon>
                      <v-icon class="mr-7" @click.stop="deleteFilterView(item.id)">mdi-delete</v-icon>
                    </span>
                    <span class="multi-drag-drop-icon">
                      <span>
                        <v-icon>mdi-dots-vertical</v-icon>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </span>
                    </span>
                  </span>
                </template>
              </v-list-item>
            </v-hover>
          </template>
        </draggable>
      </v-list>
    </v-card-text>
    <v-card-actions class="mb-7">
      <v-row>
        <v-col cols="12" class="px-7">
          <v-btn class="mt-4 font-weight-bold" dark :loading="loader" @click="applyChanges"
           v-track="'apply-customize-view-changes'">Apply</v-btn>
          <v-btn class="mt-4 font-weight-bold ml-4" outlined @click="cardOpen = false"
           v-track="'cancel-column-filter-drawer'">Cancel</v-btn>
          <v-btn v-if="$can('create','tickets')" class="mt-4 font-weight-bold ml-4"
           outlined prepend-icon="mdi-search" @click="openAddNewViewDrawer"
           v-track="'open-customize-drawer'"> 
            <v-icon
              right
              dark
              class="pr-4"
            >
              mdi-plus
            </v-icon>
              New
          </v-btn>
        </v-col>
        <v-col cols="12" class="px-7 pb-0">
          <v-divider class="mb-5"/>
          <v-list>
            <v-list-item 
              :to="{ name: 'tickets-trash' }"
              v-track="'ticket-trash'"
              class="mx-n2 card-item"
            >
              <v-icon class="mr-2">
                mdi-delete
              </v-icon>
              Trash
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import draggable from 'vuedraggable'
import { ticketMixin } from "@/mixins/ticket";
import { $filter } from "@/services/Index";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    draggable
  },
  mixins: [ticketMixin],
  data() {
    return {
      cardOpen: false,
      loader: false,
      listItems: [],
      enableScroll: true,
      filterLoader: false,
    }
  },
  computed: {
    ...mapGetters({
      loadMore: 'filters/getLoadMoreFilters',
      userPreferences: 'filters/getUserPreferences'
    })
  },
  mounted() {
    const savedTabs = this.$store.getters["filters/tabsPreferences"];
    if(savedTabs.length > 0) {
      this.listItems = savedTabs
    }
  },
  methods: {
    handleSelection(event, item) {
      if (item.isChecked && item.id === 'all_tickets') {
        // Prevent unchecking the last checkbox
        event.stopPropagation()
      }
    },
    checkboxesStatus(currentItemId) {
      // Check if all other checkboxes are unchecked
      return this.listItems.every(item => item.id === currentItemId || !item.isChecked);
    },
    openAddNewViewDrawer() {
      this.cardOpen = false
      this.$emit('open-drawer')
    },
    editFilterView(viewId) {
      this.cardOpen = false
      this.$emit('edit-filter-view', viewId)
    },
    deleteFilterView(viewId) {
      this.$emit('delete-filter-view', viewId)
    },
    applyChanges() {
      this.updateTabsPreferences(this.listItems);
    },
    handleScroll(event) {
      const bottomReached =
        event.target.scrollTop + event.target.clientHeight >=
        event.target.scrollHeight - 10
      if (this.loadMore && bottomReached && this.enableScroll && !this.filterLoader) {
        this.updateFiltersList()
      }
    },
    async updateFiltersList() {
      this.$store.commit('filters/setFiltersPage', this.filtersPage + 1)
      this.filterLoader = true
      const data = {
        page: this.filtersPage,
        per_page: this.itemsPerPage,
        q: { "id_not_in": this.userPreferences }
      };
      $filter.fetchList(data, {}).then((response) => {
        this.filterLoader = false
        let filterViews = response.data.filters
        let filtersLength = filterViews.length
        if (filtersLength === 0) {
          this.enableScroll = false
        } else {
          this.enableScroll = true
        }  
        //create list for custom view items
        const customFiltersList = filterViews.map((item) => {
          return {
            label: item.name,
            id: item.id,
            isChecked: false,
            name: item.name,
            routerName: "custom-view",
            filtername: "custom-view",
          }
        });
        this.listItems = this.listItems.concat(customFiltersList)
      }).catch(() => {
        this.filterLoader = false
        this.pageLoader = false;
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.card-view {
  position: absolute;
  z-index: 2;
  top: 42px;
  .v-card__text {
    max-height: 158px;
    overflow-y: auto;
  }
  .card-title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .card-title {
    font-size: 24px;
    font-family: Montserrat;
    font-weight: 600;
  }
  .close-icon {
    cursor: pointer;
  }
  
  .list-title {
    cursor: pointer;
    text-transform: none;
    .label {
      color: rgba(0, 0, 0, 0.8) !important;
    }
  }
  .card-item::after {
    display: none;
  }
  
  .card-item:hover {
    background-color: #eeeeee;
  }

  .low-opacity {
    opacity: 0.5;
  }
}

.multi-drag-drop-icon {
  span {
    :nth-child(1){
      margin: 0px -8px 0px -16px;
    }
    :nth-child(2){
      margin: 0px 0px 0px -24px;
    }
  }
}
</style>